import { type Choice, SPP_BRAND, type SppScope } from './liveDataAdapter';

/** Recent launches exposes country, chain, Vendor Name (SPP) and margin controls, never overview channel controls. */
export function recentLaunchesSppScope(scope: SppScope): SppScope {
  return {
    ...scope,
    channel: 'all',
    detail: 'all',
    action: null,
    eligibleOnly: false,
    brand: SPP_BRAND,
  };
}

/** Worst performers exposes country, its own SPP channel filter and the impressions range for SPP. */
export function worstPerformersSppScope(scope: SppScope, channel: Choice = 'all'): SppScope {
  return {
    ...scope,
    channel,
    detail: 'all',
    chain: 'all',
    property: 'all',
    margin: 'Exclude',
    action: null,
    eligibleOnly: false,
    brand: SPP_BRAND,
  };
}
